export enum PiniaStoreId {
  Accounting = 'accounting',
  Admin = 'admin',
  AppConfig = 'appConfig',
  Auth = 'auth',
  Company = 'company',
  ExpressMenu = 'expressMenu',
  Integrations = 'integrations',
  Inventory = 'inventory',
  Logistics = 'logistics',
  Registration = 'registration',
  Replenishment = 'replenishment',
  Reports = 'reports',
  Settings = 'settings',
  ShipAssist = 'shipAssist',
  Shop = 'shop',
  Traceability = 'traceability',
  TrustedSellers = 'trustedSellers',
  User = 'user',
}
